<template>
  <v-app id="inspire">
  <section class="loginWrap">
    <AlertCoverNotLandScape/>
    <div>
      <figure class="loginHeader">
        <img src="/static/logo-w.svg" alt="ウィズム">
      </figure>
      <section class="loginContainer">
        <h1 class="loginContainer_title">ログイン</h1>
        <div class="alart-error" v-if="loginErrorFlag">
          <v-alert color="red darken-1" icon="warning" value="true">
            ログインIDまたはパスワードが間違っています。
          </v-alert>
        </div>
        <form class="form mb-4">
          <input type="text" placeholder="ログインID" v-model="userName">
          <input type="password" placeholder="パスワード" v-model="password">
          <button type="button" id="login-button" class="mt-3 success" @click="login()">ログイン</button>
        </form>
        <v-layout row justify-center>
          <v-dialog v-model="dialog" persistent max-width="500px">
            <v-btn color="white" outline dark slot="activator">パスワードをお忘れの方</v-btn>
            <v-card>
              <v-card-title>
                <span class="headline">パスワードをお忘れの方</span>
              </v-card-title>
              <v-card-text>
                <p>お客様のログインIDと新郎または新婦のメールアドレスを入力して、送信を押してください。<br>しばらくすると、ご登録のメールアドレスに新しいパスワードが送付されます。</p>
                <v-alert outline color="error" icon="warning" :value="forgetPasswordAlert">
                  ログインIDまたはメールアドレスが間違っています。
                </v-alert>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field :rules="rules.id" label="ログインID" required prepend-icon="person" v-model="forgetPasswordLoginId"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field :rules="rules.email" label="メールアドレス" required prepend-icon="mail" v-model="forgetPasswordMailAddress"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialog = false">キャンセル</v-btn>
                <v-btn color="blue darken-1" :disabled="!formIsValid" flat @click.native="forgetPassword">送信</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </section>
    </div>
  </section>
  </v-app>
</template>

<script>
import UserService from '@/components/services/UserService.vue'
// import CustomerPlayListService from '@/components/services/CustomerPlayListService.vue'
import AlertCoverNotLandScape from '@/components/atoms/AlertCoverNotLandScape'

export default {
  name: 'Login',
  components: {AlertCoverNotLandScape},
  data () {
    return {
      userName: null,
      password: null,
      dialog: false,
      forgetPasswordAlert: false,
      loginErrorFlag: false,
      forgetPasswordLoginId: null,
      forgetPasswordMailAddress: null,
      rules: {
        id: [val => (val || '').length > 0 || 'この項目は必須です。'],
        email: [val => (val || '').length > 0 || 'この項目は必須です。']
      }
    }
  },
  computed: {
    formIsValid () {
      return (
        this.forgetPasswordLoginId &&
        this.forgetPasswordMailAddress
      )
    }
  },
  methods: {
    login () {
      this.logging('methods: login')
      let fromData = new URLSearchParams()
      fromData.append('login_id', this.userName)
      fromData.append('login_pass', this.password)
      UserService.login(fromData, (response) => {
        this.$log.debug(response)
        if (response.success) {
          let transactionId = response.transactionid
          this.$store.commit('updateStateTransactionId', transactionId)
          UserService.findCustomer(transactionId, (response) => {
            this.$log.debug(response)
            if (response.deadline) {
              let now = new Date()
              let deadLine = new Date(response.deadline + ' ' + '17:00:00')
              if (deadLine < now) {
                this.$log.debug('after deadLine')
                // 締め切り日を過ぎてしまっている場合
                if (response.playlist_commit === undefined) {
                  response.playlist_commit = 'false'
                }
                if (response.playlist_commit.toString() === 'false') {
                  /*
                  let fromData = new URLSearchParams()
                  fromData.append('transactionid', this.$store.state.transactionId)
                  CustomerPlayListService.completeCustomerPlayList(fromData, (response) => {
                  }, (error) => {
                    this.$log.error(error)
                  })
                  */
                } else {
                  this.$log.debug('already playList is commit:' + response.playlist_commit)
                }
              } else {
                this.$log.debug('before deadLine')
              }
            } else {
              this.$log.debug('deadline is undefined')
            }
          }, (error) => {
            this.$log.error(error)
          })
          // ログイン認証が通るとき
          this.$router.push('/home/playlist')
        }
      }, (error) => {
        this.logging(error)
        this.loginErrorFlag = true
      })
    },
    /**
     *  パスワードを忘れた時の処理
     */
    forgetPassword () {
      UserService.forgetPassword(this.forgetPasswordLoginId, this.forgetPasswordMailAddress, (response) => {
        if (response.success) {
          console.log(response)
          this.dialog = false
        }
      }, (error) => {
        console.error(error)
        this.forgetPasswordAlert = true
      })
    }
  }
}
</script>

<style lang="scss" scoped="">
.loginWrap {
  background: #fff url(~/static/login_main.jpg) no-repeat center center;
  background-size: cover;
  width: 100%;
  height: 100vh;
  text-align: center;
  box-sizing: border-box;
  padding-top: 20%;
  ::-webkit-input-placeholder {
    font-family: 'Source Sans Pro', sans-serif;
    color: #fff;
    font-weight: 300;
  }
  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    font-family: 'Source Sans Pro', sans-serif;
    color: #fff;
    opacity: 1;
    font-weight: 300;
  }
  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    font-family: 'Source Sans Pro', sans-serif;
    color: #fff;
    opacity: 1;
    font-weight: 300;
  }
  :-ms-input-placeholder { /* Internet Explorer 10+ */
    font-family: 'Source Sans Pro', sans-serif;
    color: #fff;
    font-weight: 300;
  }
}
.loginHeader {
  width: 250px;
  height: auto;
  margin: 0 auto 3rem;
}
.loginContainer {
  color: #fff;
  &_title {
    font-size: 2rem;
    margin-bottom: 1rem;
  }
  .alart-error {
    width: 350px;
    margin: 20px auto;
  }
  form{
    position: relative;
    z-index: 2;
      a {
        display: block;
      }
    input{
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      outline: 0;
      border: 1px solid #fff;
      background-color: rgba(255,255,255,0.2);
      width: 250px;
      border-radius: 3px;
      padding: 10px 15px;
      margin: 0 auto 10px auto;
      display: block;
      text-align: center;
      font-size: 18px;
      color: #fff;
      transition-duration: 0.25s;
      font-weight: 300;
      box-sizing: border-box;
      &:hover{
        background-color: rgba(255,255,255,0.4);
      }
      &:focus{
        background-color: #fff;
        width: 300px;
        color: #15c06a;
      }
    }
    button{
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      outline: 0;
      background-color: #15c06a;
      border: 0;
      padding: 10px 15px;
      color: #fff;
      border-radius: 3px;
      width: 250px;
      cursor: pointer;
      font-size: 18px;
      transition-duration: 0.25s;
      &:hover{
        background-color: #fff;
        color: #15c06a;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue